export class ListItem {
	public name: string;
	public value: string;
	public classItem?: string;
	
	constructor(
		name: string,
		value: string,
		classItem?: string
		) {

		this.name = name;
		this.value = value;
		this.classItem = classItem;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/list-confirmation/model/list-item.ts